/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CampaignAudience } from './CampaignAudience';
import {
    CampaignAudienceFromJSON,
    CampaignAudienceFromJSONTyped,
    CampaignAudienceToJSON,
} from './CampaignAudience';

/**
 * 
 * @export
 * @interface CreateCampaignAudience201Response
 */
export interface CreateCampaignAudience201Response {
    /**
     * 
     * @type {CampaignAudience}
     * @memberof CreateCampaignAudience201Response
     */
    data?: CampaignAudience;
}

/**
 * Check if a given object implements the CreateCampaignAudience201Response interface.
 */
export function instanceOfCreateCampaignAudience201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateCampaignAudience201ResponseFromJSON(json: any): CreateCampaignAudience201Response {
    return CreateCampaignAudience201ResponseFromJSONTyped(json, false);
}

export function CreateCampaignAudience201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCampaignAudience201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CampaignAudienceFromJSON(json['data']),
    };
}

export function CreateCampaignAudience201ResponseToJSON(value?: CreateCampaignAudience201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CampaignAudienceToJSON(value.data),
    };
}

